/* Office Type -> Bootstrap Label Type Mapping Filter
 *
 * Angular Module: "trackerbase-app.filters.office-type-label-type-filter"
 * Filter exposed as: tbOfficeTypeLabelType
 */

import angular from "angular";

// TODO: Remove hard-coded office type names
const officeTypeLabelTypeLookupTable = new Map([
    ["President", "primary"],
    ["Vice President", "primary"],
    ["Governor", "info"],
    ["Lt. Governor", "info"],
    ["Senate", "success"],
    ["House", "danger"],
    ["Secretary of State", "info"],
    ["Attorney General", "info"],
    ["State Legislature", "default"],
    ["Other", "default"]
]);

function officeTypeLabelFilter(officeTypeName) {
    let labelTypeName = officeTypeLabelTypeLookupTable.get(officeTypeName);

    if (angular.isUndefined(labelTypeName)) {
        labelTypeName = "default";
    }

    return labelTypeName;
}

function officeTypeLabelTypeFilterFactory() {
    return officeTypeLabelFilter;
}

officeTypeLabelTypeFilterFactory.$inject = [];

export default angular
    .module("trackerbase-app.filters.office-type-label-type-filter", [])
    .filter("tbOfficeTypeLabelType", officeTypeLabelTypeFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/filters/OfficeTypeLabelTypeFilter.js
// module id = a9od
// module chunks = 1